import Toastify from "toastify-js";

export default () => {
	const compareBtns = document.querySelectorAll("[data-compare]")

	if (compareBtns && compareBtns.length > 0) {
		const notifyBar = document.querySelector(".compare-snackbar");
		let addedConfirmationBar = null;
		let notifyBarContent = "";

		if (notifyBar) {
			const notifyBarContentElement = notifyBar.querySelector(".compare-snackbar__content");

			if (notifyBarContentElement) {
				notifyBarContent = notifyBarContentElement.innerHTML;
				notifyBarContentElement.remove();
			}
		}

		compareBtns.forEach((btn) => {
			btn.addEventListener("click", function (e) {
				e.preventDefault()
				e.stopPropagation()

				const type = this.dataset.type,
					editableCookie = document.cookie.split(";"),
					that = this

				let updatedCookie = null

				editableCookie.map((item) => {
					if (item.indexOf(`compare_${type}`) >= 0) {
						const compareItems = JSON.parse(item.split("=")[1]);

						let newArray = [];
						const compId = parseInt(that.dataset.compare);
						if (compareItems.indexOf(compId) == -1)
							newArray = [
								...new Set([...compareItems, +compId]),
							]
						else {
							newArray = compareItems.reduce(
								(previousValue, currentValue) => {
									if (currentValue !== +compId) {
										return [...previousValue, currentValue]
									}
									return previousValue
								},
								[]
							)
						}

						updatedCookie = `compare_${type}=${JSON.stringify(
							newArray
						)}; path=/`
					}
				})

				document.cookie = updatedCookie
					? updatedCookie
					: `compare_${type}=${JSON.stringify([+this.dataset.compare])}; path=/`;
				refreshCompareMenu();
			})
		})
	}

	const removecompareItemBtns = document.querySelectorAll(
		".comparison-table [data-remove]"
	)

	if (removecompareItemBtns && removecompareItemBtns.length > 0) {
		removecompareItemBtns.forEach((item) => {
			item.addEventListener("click", function (e) {
				console.log("click")
				const editableCookie = document.cookie.split(";"),
					type = this.dataset.type

				editableCookie.map((item) => {
					if (item.indexOf(`compare_${type}`) >= 0) {
						const compareItems = JSON.parse(item.split("=")[1])

						const newArray = compareItems.reduce(
							(previousValue, currentValue) => {
								if (currentValue !== +this.dataset.remove) {
									return [
										...previousValue,
										currentValue
									]
								}
								return previousValue
							},
							[]
						)


						document.cookie = `compare_${type}=${JSON.stringify(
							newArray
						)}; path=/`;

						refreshCompareMenu();
					}
				})

				const target = e.currentTarget;
				const targetDataRemove = target.dataset.remove;
				if(targetDataRemove)
					target.closest(".comparison-table").querySelectorAll("[data-item-id='" + targetDataRemove + "']").forEach( tableEl => {
						tableEl.remove();
					})
			})
		})
	}

	// for map purpose, cant wait for map render to fire actions, need to add listener to parent element

	const mapEventDelegation = document.querySelector("#map")

	if (mapEventDelegation) {
		mapEventDelegation?.addEventListener("click", function (e) {
			let compareID = null,
				compareType = null
			if (e.target.hasAttribute("data-compare")) {
				compareID = parseInt(e.target.getAttribute("data-compare"))
				compareType = e.target.getAttribute("data-type")
				e.target.classList.add("compare")
			}

			if (e.target.closest("[data-compare]")) {
				compareID = parseInt(e.target
					.closest("[data-compare]")
					.getAttribute("data-compare"))
				compareType = e.target
					.closest("[data-compare]")
					.getAttribute("data-type")

				e.target.closest("[data-compare]").classList.add("compare")
			}

			if (compareID !== null) {
				const editableCookie = document.cookie.split(";")

				let updatedCookie = null

				// this.classList.add("compare")

				editableCookie.map((item) => {
					if (item.indexOf(`compare_${compareType}`) >= 0) {
						const compareItems = JSON.parse(item.split("=")[1])

						let newArray = [];
						if(compareItems.indexOf(compareID) == -1)
							newArray = [
								...new Set([...compareItems, +compareID]),
							]
						else {
							newArray = compareItems.reduce(
								(previousValue, currentValue) => {
									if (currentValue !== +compareID) {
										return [...previousValue, currentValue]
									}
									return previousValue
								},
								[]
							)
						}


						updatedCookie = `compare_${compareType}=${JSON.stringify(
							newArray
						)}; path=/`
					}
				})

				document.cookie = updatedCookie
					? updatedCookie
					: `compare_${compareType}=${JSON.stringify([+compareID])}; path=/`;

			}
			refreshCompareMenu();
		})
	}

	refreshCompareMenu();

}

const showAddConfirmInfo = (container, text) => {
	if (container && text) {
		Toastify({
			text: text,
			selector: container,
			duration: 3000,//-1,
			close: true,
			gravity: "top", // `top` or `bottom`
			position: "center", // `left`, `center` or `right`
			stopOnFocus: true, // Prevents dismissing of toast on hover
			escapeMarkup: false,
			/*
			offset: {
				y: -5,
			},*/

			onClick: function () {
			} // Callback after click
		})
			.showToast()
		;
	}
}

const refreshCompareMenu = (favoriteType, newArray) => {
		const browserCookie = document.cookie.split(";"),
			compareElement = document.querySelector(".user-menu__compare");

		document.querySelectorAll("[data-compare]").forEach((item) => {
			item.classList.remove("compare");
		})

		if (Array.isArray(browserCookie)) {

			var totalComps = 0;

			browserCookie.forEach((item) => {

					if (item.indexOf(`compare_warehouse`) >= 0) {
						const favItems = JSON.parse(item.split("=")[1]);

						if (Array.isArray(favItems)) {
							if (document.querySelector(".comp-warehouse-num")) {
								if (favItems.length)
									document.querySelector(".comp-warehouse-num").innerHTML = ' (' + favItems.length + ')';
								else
									document.querySelector(".comp-warehouse-num").innerHTML = '';
							}

							compareElement.setAttribute(`data-count-warehouse`, favItems.length);
							totalComps += favItems.length;

							favItems.forEach((itemId) => {
								if (document.querySelector("[data-compare='" + itemId + "']"))
									document.querySelector("[data-compare='" + itemId + "']").classList.add("compare");
							})
						}
					}

					if (item.indexOf(`compare_land`) >= 0) {
						const favItems = JSON.parse(item.split("=")[1]);
						if (Array.isArray(favItems))
						{
							if (document.querySelector(".comp-land-num")) {
								if (favItems.length)
									document.querySelector(".comp-land-num").innerHTML = ' (' + favItems.length + ')';
								else
									document.querySelector(".comp-land-num").innerHTML = '';
							}

							compareElement.setAttribute(`data-count-office`, favItems.length)
							totalComps += favItems.length;
							favItems.forEach((itemId) => {
								if (document.querySelector("[data-compare='" + itemId + "']"))
									document.querySelector("[data-compare='" + itemId + "']").classList.add("compare");
							})
						}
					}

					if (item.indexOf(`compare_office`) >= 0) {
						const favItems = JSON.parse(item.split("=")[1]);
						if (Array.isArray(favItems)) {
							if (document.querySelector(".comp-office-num")) {
								if (favItems.length)
									document.querySelector(".comp-office-num").innerHTML = ' (' + favItems.length + ')';
								else
									document.querySelector(".comp-office-num").innerHTML = '';
							}

							compareElement.setAttribute(`data-count-land`, favItems.length)
							totalComps += favItems.length;

							favItems.forEach((itemId) => {
								if (document.querySelector("[data-compare='" + itemId + "']"))
									document.querySelector("[data-compare='" + itemId + "']").classList.add("compare");
							})
						}
					}


					if (totalComps > 0) {
						compareElement.setAttribute("data-count", totalComps)
					} else {
						compareElement.removeAttribute("data-count");
					}
				}
			)
			;
		}

	}
;
document.addEventListener("refresh-comps", refreshCompareMenu);